/**
 * # Label
 *
 * React component for rendering a label element.
 *
 * ## Props
 * - `className` (string): Additional CSS class name for the label.
 * - `htmlFor` (string): The ID of the form element associated with the label.
 *
 * ## Usage
 *
 * ```jsx
 * import React from 'react';
 * import Label from './Label.react';
 *
 * const MyComponent = () => {
 *   return (
 *     <div>
 *       <Label htmlFor="myInput">Name:</Label>
 *       <input id="myInput" type="text" />
 *     </div>
 *   );
 * };
 * ```
 */

import React from 'react';

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const Label = (props: LabelProps) => (
  // oxlint-disable-next-line jsx-a11y/label-has-associated-control -- generic wrapper; association is the caller's responsibility via htmlFor/children
  <label {...props} />
);

export default Label;
